import RoleAndPermissionContainer from "./RoleAndPermission.container";

export default RoleAndPermissionContainer;
